module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxnIGZpbGw9IiM1NDU5NWQiPg0KICAgIDxwYXRoIGQ9Ik0gMTAgMTEgQyA0LjA4IDExIDIgMTQgMiAxNiBMIDIgMTkgTCAxOCAxOSBMIDE4IDE2IEMgMTggMTQgMTUuOTIgMTEgMTAgMTEgWiIvPg0KICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iNS41IiByPSI0LjUiLz4NCiAgPC9nPg0KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.svg?data
// module id = bhr7
// module chunks = 1